/**
 * @class Header
 * @description Class used to handle different actions for the page header.
 */
class Header {
  openBtn: HTMLCollectionOf<Element>;
  closeBtn: HTMLCollectionOf<Element>;
  overlayMenu: HTMLCollectionOf<Element>;
  constructor() {
    // bind methods
    this.openHeader = this.openHeader.bind(this);
    this.closeHeader = this.closeHeader.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.overlayMenu = document.getElementsByClassName("overlay-menu");
    this.openBtn = document.getElementsByClassName(
      "js-desktop-header-open-btn"
    );
    // bind event to open buttons if exist
    if (this.openBtn) {
      for (let index = 0; index < this.openBtn.length; index++) {
        const element = this.openBtn[index];
        element.addEventListener("click", this.openHeader);
      }
    }
    this.closeBtn = document.getElementsByClassName(
      "js-desktop-header-close-btn"
    );
    // bind event to close buttons if exist
    if (this.closeBtn) {
      for (let index = 0; index < this.closeBtn.length; index++) {
        const element = this.closeBtn[index];
        element.addEventListener("click", this.closeHeader);
      }
    }
  }

  /**
   * @method openHeader
   * @memberof Header
   * @param event {event}
   * @returns void
   * @description -
   */
  openHeader(event): void {
    let btn = event.currentTarget;
    this.toggleMenu(btn);
  }

  /**
   * @method closeHeader
   * @memberof Header
   * @param event {event}
   * @returns void
   * @description -
   */
  closeHeader(event): void {
    let btn = event.currentTarget;
    this.toggleMenu(btn);
  }

  /**
   * @method toggleMenu
   * @memberof Header
   * @param btn {HTMLElement} Button which is clicked.
   * @param action {open | close} Action performed, open or close.
   * @returns void
   * @description -
   */
  toggleMenu(btn: HTMLElement): void {
    let header = btn.closest(".js-header");
    let overlay = header.getElementsByClassName("overlay-menu");
    overlay[0].classList.toggle("left-0");

    for (let index = 0; index < this.openBtn.length; index++) {
      const element = this.openBtn[index];
      element.classList.toggle("opacity-0");
    }
  }
}

const H = new Header();

export default H;
